<template>
    <div>
        <!-- <top-bar></top-bar> -->
        <top-slider></top-slider>
        <top-menu></top-menu>

        <div class="page_content_box">
            <div class="wrap">


                <div class="resume_box">
                        <!-- 投递信息 -->
                        <!-- <div class="delivery">
                            <div class="resume_title">
                                <h2>投递信息</h2>
                            </div>
                            <div class="delivery_con">
                                <div><h3>投递职位:</h3><span>司机</span></div>
                                <div><h3>投递时间:</h3><span>2021-01-10</span></div>
                            </div>
                        </div> -->
                        <!-- 基本信息 -->
                        <div class="info">
                            <div class="resume_title">
                                <h2>基本信息</h2>
                            </div>
                            <div class="info_con">
                                <div class="pic"><img :src="resumeContent.photo ? resumeContent.photo : require('../../assets/images/icon_avatar_default.png')" alt=""></div>
                                <div class="textCon">
                                    <div class="box">
                                        <ul>
                                            <li><h3>姓名:</h3><span>{{resumeContent.name}}</span></li>
                                            <li><h3>性别:</h3><span>{{sexData[resumeContent.sex]}}</span></li>
                                            <li><h3>年龄:</h3><span>{{resumeContent.age}}</span></li>
                                        </ul>
                                    </div>
                                    <div class="box">
                                        <ul>
                                            <li><h3>工作经验:</h3><span>{{resumeContent.workExperience}}</span></li>
                                            <li><h3>期望岗位:</h3><span>{{resumeContent.expectedPosition}}</span></li>
                                            <li><h3>期望薪资:</h3><span>{{resumeContent.salary}}</span></li>
                                        </ul>
                                    </div>
                                    <div class="box">
                                        <h3>居住地址:</h3><span>{{resumeContent.habitation}}</span>
                                    </div>
                                    <div class="box">
                                        <h3>手机号码:</h3><span>{{resumeContent.mobile}}</span>
                                    </div>
                                    <div class="box">
                                        <h3>电子邮箱:</h3><span>{{resumeContent.email}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 自我介绍 -->
                        <div class="intro">
                            <div class="resume_title">
                                <h2>自我介绍</h2>
                            </div>
                            <div class="intro_con">
                                <p>{{resumeContent.introduce}}</p>
                            </div>
                        </div>

                        <!-- 教育经历 -->
                        <div class="education">
                            <div class="resume_title">
                                <h2>教育经历</h2>
                            </div>
                            <div class="education_con">
                                <ul>
                                    <li v-for="(item,index) in resumeContent.resumeEducationExperienceDOList" :key="index"><span class="date">{{item.startTime}}-{{item.endTime}}</span><span class="colege">{{item.school}}</span><span class="detail">{{item.education}} | {{item.major}}</span></li>
                                </ul>   
                            </div>
                        </div>

                        <!-- 工作经历 -->
                        <div class="education">
                            <div class="resume_title">
                                <h2>工作经历</h2>
                            </div>
                            <div class="education_con">
                                <ul>
                                    <li v-for="(item,index) in resumeContent.resumeWorkExperienceDOList" :key="index"><span class="date">{{item.startTime}}-{{item.endTime}}</span><span class="colege">{{item.company}}</span><span class="detail">{{item.position}} | {{item.operatingDuty}}</span></li>
                                </ul>   
                            </div>
                        </div>

                        <!-- 培训经历 -->
                        <div class="education">
                            <div class="resume_title">
                                <h2>培训经历</h2>
                            </div>
                            <div class="education_con">
                                <ul>
                                    <li v-for="(item,index) in resumeContent.resumeTrainingExperienceDOList" :key="index"><span class="date">{{item.startTime}}-{{item.endTime}}</span><span class="colege">{{item.course}}</span><span class="detail">{{item.mechanism}}</span></li>
                                </ul>   
                            </div>
                        </div>

                        <!-- 语言能力 -->
                        <div class="education">
                            <div class="resume_title">
                                <h2>语言能力</h2>
                            </div>
                            <div class="education_con">
                                <ul>
                                    <li v-for="(item,index) in resumeContent.resumeLanguageAbilityDOList" :key="index"><span class="colege">{{item.languages}}</span><span class="detail">{{item.proficiency}}</span></li>
                                </ul>   
                            </div>
                        </div>

                        <!-- 获得证书 -->
                        <div class="education">
                            <div class="resume_title">
                                <h2>获得证书</h2>
                            </div>
                            <div class="education_con">
                                <ul>
                                    <li v-for="(item,index) in resumeContent.resumeObtainCertificateDOList" :key="index"><span class="colege">{{item.certificateName}}</span><span class="detail">{{item.certificateTime}}</span></li>
                                </ul>   
                            </div>
                        </div>

                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
// import TopBar from '@/components/TopBar.vue'
import Footer from '@/components/Footer.vue'
import TopMenu from '@/components/TopMenu.vue'
import TopSlider from '@/components/TopSlider.vue'
import { unitGetResumeDetail } from '@/service/api.js'
import { dateFormat, createContentMeta } from '@/utils/util.js'
export default {
    // components: { TopBar,Footer,TopSlider,TopMenu },
    components: { Footer,TopSlider,TopMenu },
    data() {
        return {
            resumeContent:{},
            sexData:{
                1:'男',
                2:'女',
            }
        }
    },
    mounted () {
        unitGetResumeDetail(this.$route.params.id).then(data=>{
            console.log('unitGetResumeDetail',data);
            if (data.code !==0) {
                this.$message.error(data.msg)
            }else{
                this.resumeContent = data.data
                this.resumeContent.birth = dateFormat(this.resumeContent.birth,'Y-M-D')
                if (this.resumeContent.resumeWorkExperienceDOList.length) {
                    this.resumeContent.resumeWorkExperienceDOList.forEach(el => {
                        el.endTime = dateFormat(el.endTime,'Y-M-D')
                        el.startTime = dateFormat(el.startTime,'Y-M-D')
                    });
                }
                if (this.resumeContent.resumeTrainingExperienceDOList.length) {
                    this.resumeContent.resumeTrainingExperienceDOList.forEach(el => {
                        el.endTime = dateFormat(el.endTime,'Y-M-D')
                        el.startTime = dateFormat(el.startTime,'Y-M-D')
                    });
                }
                if (this.resumeContent.resumeEducationExperienceDOList.length) {
                    this.resumeContent.resumeEducationExperienceDOList.forEach(el => {
                        el.endTime = dateFormat(el.endTime,'Y-M-D')
                        el.startTime = dateFormat(el.startTime,'Y-M-D')
                    });
                }
                if (this.resumeContent.resumeObtainCertificateDOList.length) {
                    this.resumeContent.resumeObtainCertificateDOList.forEach(el => {
                        el.certificateTime = dateFormat(el.certificateTime,'Y-M-D')
                    });
                }
                // 添加meta标签
                let temp = {
                  'ColumnName': '个人简历',
                  'ColumnType': '个人简历',
                  'ArticleTitle': this.resumeContent.name,
                  'PubDate': this.resumeContent.pushTime,
                  'ContentSource': '海淀区退役军人事务局',
                  'Author': this.resumeContent.name
                }
                createContentMeta(temp)
            }
        });
    },
}
</script>

<style lang="less" scoped>
.resume_box {
    overflow: hidden;
    padding: 0 10px 50px;
    .resume_title {
        overflow: hidden;
        padding-bottom: 10px;
        border-bottom: solid 1px #f1f1f1;
        h2 {
            font-size: 20px;
            font-weight: 600;
            color: #18388b;
            line-height: 1;
            display: inline-block;
            vertical-align: top;
        }
    }
    .delivery {
        margin-top: 20px;
        overflow: hidden;
        .delivery_con {
            margin-top: 15px;
            padding-bottom: 30px;
            h3 {
                font-weight: 600;
                display: inline-block;
                padding-right: 5px;
            }
            div {
                display: inline-block;
                &:last-child {
                     margin-left: 300px;
                }
            }
        }
    }
    .info {
        margin-top: 20px;
        overflow: hidden;
        .info_con {
            overflow: hidden;
            margin-top: 15px;
            width: 800px;
            .pic {
                width: 130px;
                height: 182px;
                float: left;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .textCon {
                width: 610px;
                height: 182px;
                float: right;
                overflow: hidden;
                .box {
                    margin-bottom: 15px;
                    ul {
                        overflow: hidden;
                    }
                    li {
                        float: left;
                        width: 200px;
                        line-height: 1;
                    }
                    h3 {
                        font-weight: 600;
                        display: inline-block;
                        padding-right: 5px;
                    }
                }
            }
        }
    }
    .intro {
        margin-top: 20px;
        overflow: hidden;
        .intro_con {
            overflow: hidden;
            margin-top: 15px;
            p {
                text-indent: 2em;
                line-height: 1.6;
                text-align: justify;
            }
        }
    }
    .education {
        margin-top: 20px;
        overflow: hidden;
        .education_con {
            overflow: hidden;
            margin-top: 15px;
            ul {
                li {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 15px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    .date {
                        display: flex;
                        align-items: center;
                        width: 250px;
                        &::before {
                            content: '';
                            width: 15px;
                            height: 15px;
                            display: inline-block;
                            vertical-align: middle;
                            margin: 0 10px 0 0;
                            background: url(../../assets/images/icon_circle_ring.png) no-repeat;
                        }
                    }
                    .colege {
                        display: inline-block;
                        display: flex;
                        align-items: center;
                        padding: 0 40px;
                        flex: 1;
                    }
                    .detail {
                        text-align: right;
                        display: flex;
                        align-items: center;
                        width: 160px;
                    }
                }
            }
        }
    }
    .work_exp {
        margin-top: 20px;
        overflow: hidden;
        .work_exp_con {
            overflow: hidden;
            margin-top: 15px;
            padding-left: 2px;
            .activity_box {
                line-height: 1.4;
                font-size: 16px;
                .line {
                    margin: 0 10px;
                    font-weight: 600;
                }
                .tit {
                    font-weight: 600;
                    margin-right: 5px;
                }
            }
        }
    }
    .train_exp {
        margin-top: 20px;
        overflow: hidden;
    }
    .language {
        margin-top: 20px;
        overflow: hidden;
    }
    .btn_save {
        width: 160px;
        background-color: #18388b;
        border: none;
        display: block;
        margin: 20px auto 0;
    }
}
</style>
<style lang="less">
.resume_box {
    .el-timeline-item__node {
        width: 15px;
        height: 15px;
        background-color: #18388b;
        left: -2px;
        &::before {
            content: '';
            width: 11px;
            height: 11px;
            background-color: #FFF;
            border-radius: 50%;
            position: absolute;
            left: 50%;
            top: 50%;
            margin: -5.5px 0 0 -5.5px;
        }
    }
    .el-timeline-item__timestamp {
        color: #333;
        font-size: 14px;
        font-weight: 600;
    }
}
</style>